exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upper[data-v-baeac5e4]{font-family:DMSans-Regular}.el-icon-d-arrow-right[data-v-baeac5e4]{transform:rotate(-90deg);transition:transform 0.3s ease}.el-icon-d-arrow-right.is-expanded[data-v-baeac5e4]{transform:rotate(90deg)}\n", ""]);

// exports
